export const SHOW_NEED_LOGIN_MODAL = 'SHOW_NEED_LOGIN_MODAL';
export const CLOSE_NEED_LOGIN_MODAL = 'CLOSE_NEED_LOGIN_MODAL';